module.exports = __webpack_public_path__ + "img-front/register/logo.49ffeaa0.svg";